import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  addressError: null,
  amount: 0,
  clientToken: null,
  initAuthFlow: null,
  paymentMethod: null,
  details: null,
  nonce: null,
  ready: false,
};

export const paypalSlice = createSlice({
  name: 'paypal',
  initialState,
  reducers: {
    getClientTokenSuccess: (state, action) => {
      const { clientToken } = action.payload;

      state.clientToken = clientToken;
    },
    checkout: (state) => {
      state.processing = false;
    },
    checkoutProcessing: (state) => {
      state.processing = true;
    },
    checkoutSuccess: (state) => {
      state.processing = false;
    },
    checkoutFailure: (state) => {
      state.processing = false;
    },
    paymentSuccess: (state, action) => {
      const { details, nonce } = action.payload;

      state.details = details;
      state.nonce = nonce;
    },
    reset: (state) => {
      state.addressError = null;
      state.amount = 0;
      state.clientToken = null;
      state.initAuthFlow = null;
      state.paymentMethod = null;
      state.details = null;
      state.nonce = null;
    },
  },
});

export const selectPaypal = (state) => state.paypal;
export const selectClientToken = (state) => state.paypal.clientToken;

export default paypalSlice.reducer;
